/**
 * Visitor consent as mirrored by www.facetflux.com into the `ff_consent` cookie
 * (Domain=.facetflux.com), so the app on app.facetflux.com can honour the
 * choice made on the marketing site's banner / "Cookie settings".
 *
 * Cookie format: `v{version}.a{0|1}.m{0|1}.t{unixSeconds}`
 *   a = statistics / analytics, m = marketing / ads. Example: `v1.a1.m0.t1762207200`.
 *
 * Opt-in: no cookie, a malformed cookie or an unknown version means nothing is
 * granted. Keep CONSENT_VERSION in sync with FacetFlux-Web lib/consent-defaults.ts
 * and the backend NBoilerplate.Identity.Attribution.ConsentCookie.
 *
 * Local development: set a host-only cookie in the console, e.g.
 *   document.cookie = "ff_consent=v1.a1.m0.t0; path=/"
 */

export const CONSENT_COOKIE = "ff_consent";
export const CONSENT_VERSION = 1;

const FORMAT = /^v(\d{1,3})\.a([01])\.m([01])\.t(\d{1,12})$/;

export function parseConsentCookie(value) {
  if (!value) return null;
  let decoded;
  try {
    decoded = decodeURIComponent(value).trim();
  } catch {
    return null;
  }
  const m = decoded.match(FORMAT);
  if (!m) return null;
  const version = Number(m[1]);
  if (version !== CONSENT_VERSION) return null;
  const ts = Number(m[4]);
  return {
    version,
    analytics: m[2] === "1",
    ads: m[3] === "1",
    decidedAt: ts > 0 ? new Date(ts * 1000).toISOString() : null,
  };
}

export function readConsentCookie(cookieString = typeof document !== "undefined" ? document.cookie : "") {
  for (const part of (cookieString || "").split(";")) {
    const idx = part.indexOf("=");
    if (idx < 0) continue;
    if (part.slice(0, idx).trim() === CONSENT_COOKIE) {
      return parseConsentCookie(part.slice(idx + 1).trim());
    }
  }
  return null;
}

export const hasAnalyticsConsent = () => Boolean(readConsentCookie()?.analytics);
